import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    font-family: 'Righteous', cursive;
  }
`
const BeanMod = styled.div`
background-color: grey;
width: 100%;
height: 100%;
z-index: 2;
`
const Bubble = styled.div`
padding 10px;
border-radius 20px;
box-shadow: 8px 6px 9px 3px #888888, -9px 4px 9px 1px #888888;
position: fixed;
z-index: 4;
opacity: 1;
bottom: 10%;
left: 23%;
font-size: 15px;
background-color: #ffffff;
@media (max-width: 600px) {
    left: 4%;
}
`
const Been = styled.img`
opacity: 1.0;
position: fixed;
z-index: 3;
bottom: 10%;
height: 150px;
width: 100px;
`

const Bod = styled.div`
    display: flex;
    width: 600px;
    margin-left: 20%;
    flex-direction: column;
    justify-content: center;
    font-family: 'Righteous', cursive;
    @media (max-width: 600px) {
        width: 100%;
        height: 100%;
        margin-left: 0%;
    }

`   
const Bar = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
@media (max-width: 600px) {
 
}

`

const Small = styled.p`
font-family: 'Libre Barcode 128 Text', cursive;
font-size: 24px;
color: #6c757d;
display: flex;
flex-direction: row;
justify-content: space-between;
@media (max-width: 600px) {
 
}
`
const Gator = styled.div`
font-family: 'Libre Barcode 128 Text', cursive;
font-size: 48px;
display: flex;
flex-direction: row;
justify-content: space-between;
@media (max-width: 600px) {
 
}
`
const Fator = styled.div`
font-family: 'Libre Barcode 128 Text', cursive;
font-size: 30px;
margin-top: 10px;
text-align: center;
@media (max-width: 600px) {
}
`
const Goals = styled.img`
margin: 2.5%;
    width: 80%;
    height 90%;
    margin-bottom: 10%;
    margin-left: 10%;
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: 8px 6px 9px 3px #888888, -9px 4px 9px 1px #888888;
  `
  const Cont = styled.div`
  display: flex;
  flex-direction: row;
  width: 335px;
  color: #6c757d;

  `
  const Miss = styled.img`
      margin: 2.5%;
      margin-right: 20px;
      margin-top: 0%;
      width: 140px;
      height 240px;
      margin-bottom: 10%;
      margin-left: 10%;
      background-color: #ffffff;
      border-radius: 20px;
      box-shadow: 8px 6px 9px 3px #888888, -9px 4px 9px 1px #888888;
    `
const Text = styled.p`
margin: 20px;
font-size: 20px;
color: #6c757d;
justify-content: left;
@media (max-width: 600px) {
    font-size: 10px;
    margin: 20px;
}

`

const Box = styled.div`
    margin-top: 2.5%;
    height: 600px;
    width: 600px;
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: 8px 6px 9px 3px #888888, -9px 4px 9px 1px #888888;
    overflow: auto;
    &::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 600px) {
        margin-top: 20%;
        margin-bottom: 10%;
        height: 300px;
        width: 80%;
        margin-left: 10%;
    }
    `

    const BoxIn = styled.div`
    margin-top: 2.5%;
    height: 600px;
    width: 600px;
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow:inset 3px 9px 9px 5px #888888, inset -9px 4px 9px 1px #888888;
    overflow: auto;
    &::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 600px) {
        margin-top: 2.5%;
        height: 300px;
        width: 300px;
        margin-left: 10%;
    }
    `
    const BoxOut = styled.div`
    margin-top: 2.5%;
    height: 100px;
    width: 600px;
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow:inset 3px 9px 9px 5px #888888, inset -9px 4px 9px 1px #888888;
    overflow: auto;
    &::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 600px) {
        margin-top: 2.5%;
        height: 100px;
        width: 300px;
        margin-left: 10%;
    }
    `


export {GlobalStyle, Box, Gator, Goals, Fator, Small, BoxIn, Bar, Bod, Text, Miss, Cont, BeanMod, Been, Bubble, BoxOut};